// Generated from the official ANT+ Directory: https://www.thisisant.com/directory
// Source endpoint: /directory/ajax_filter_json/~/~/~/~
// Product count fetched: 1100; unique selector labels: 1092
export const ANT_PLUS_DEVICES = [
  "4iiii Innovations Inc - Fliiiight",
  "4iiii Innovations Inc - Podiiiium",
  "4iiii Innovations Inc - PRECISION",
  "4iiii Innovations Inc - Precision 3+ Powermeter",
  "4iiii Innovations Inc - PRECISION PRO",
  "4iiii Innovations Inc - Precision3 Powermeter",
  "4iiii Innovations Inc - Precision3+ Pro Powermeter",
  "4iiii Innovations Inc - Sportiiii",
  "4iiii Innovations Inc - Viiiiva",
  "A\u0026D Medical - UA-851ANT eHealth Wireless Blood Pressure Monitor",
  "A\u0026D Medical - UC-324ANT eHealth Wireless Precision Scale",
  "Abawo - KeAnt",
  "ActiGraph - wActiSleep+ Monitor",
  "ActiGraph - wGT3X+ Activity Monitor",
  "Adidas - miCoach CONNECT for iPhone/iPod touch",
  "Adidas - miCoach Heart Rate Monitor",
  "Adidas - miCoach Stride Sensor",
  "Aerosensor",
  "ALATECH - ALA CS006 Heart Rate Transmitter",
  "ALATECH - Dual Mode Heart Rate Strap",
  "ALATECH - Dual Mode Speed and Cadence Sensor",
  "ALATECH - Magnet-less Speed and Cadence Sensor",
  "ANT Wireless - ANT Radio Service",
  "ANT Wireless - ANT USB Service",
  "ANT Wireless - ANT+ Plugins",
  "Artengo - Personal Coach",
  "Artengo TW Personal Coach",
  "AsViva - SBT1 Procycling",
  "Athlosoft - ERGOHR",
  "BAFANG - DP C030.CA",
  "Baron Controls LLC - ProShift",
  "Beurer - Chest Strap",
  "Beurer - PM70",
  "Beurer - PM80",
  "Beurer - PM90",
  "Beurer - SpeedboxII",
  "bf1systems® Power Cranks",
  "BIPR - HR2VP",
  "BIPR Arcade - Footpod Arcade Running",
  "BKOOL - Cycling Simulator - Android",
  "BKOOL - Cycling Simulator - iOS",
  "BKOOL - Cycling Simulator - OSX",
  "BKOOL - Sensor de Cadencia (Cadence Sensor)",
  "BKOOL - Smart Go",
  "BKOOL ANT+ Heart Rate Chest Strap",
  "Bkool Cycling Simulator",
  "Bkool Smart Pro",
  "Blackburn - Neuro Cadence Sensor",
  "Blackburn - Neuro Heart Rate Strap",
  "Blackburn - Neuro Speed Sensor",
  "Blenphi - Javascript Watch Face - CIQ APP",
  "BlueLeza - HRM Blue",
  "BODY BIKE Connect Indoor Cycle",
  "BODY BIKE Heart Rate Transmitter",
  "BODY BIKE Performance Console",
  "BODY BIKE SMART+",
  "BOLTT - GP1 Footpod",
  "Bontrager - ANT+ Digital Bike Cadence Sensor",
  "Bontrager - ANT+ Digital Bike Speed Sensor",
  "Bontrager - ANT+ Digital Softstrap Heart Rate Belt",
  "Bontrager - Duotrap Digital Speed/Cadence Sensor",
  "Bontrager - DuoTrap S Digital Sensor",
  "Bontrager - Flare RT Tail Light",
  "Bontrager - Interchange Digital Cadence Sensor",
  "Bontrager - Interchange Digital Combo Sensor",
  "Bontrager - Interchange Digital Speed Sensor",
  "Bontrager - Ion 350 RT",
  "Bontrager - Ion 450 RT",
  "Bontrager - Ion 700 RT",
  "Bontrager - Node 1.1",
  "Bontrager - Node 2.1",
  "Bontrager - SpeedTrap Digital Speed Sensor",
  "Bontrager - Transmitr Remote",
  "Bontrager - Trek - RIDEtime Elite",
  "Bontrager - Trip 300",
  "Bontrager Flare RT Rear Bike Light",
  "Bontrager Ion 200 RT Front Bike Light",
  "Brim Brothers Ltd. - Zone DPMX",
  "Bryton - Gardia R300L",
  "Bryton - Rider 100",
  "Bryton - Rider 310",
  "Bryton - Smart HR Monitor",
  "BSX Insight - BSXInsight",
  "B\u0027TWIN - COUNT 14+ Wireless Counter",
  "B\u0027TWIN - Heartwear ANT+ cardio belt",
  "B\u0027TWIN ANT+ Speed/Rate Sensor",
  "CadenceVR.com - Cadence Virtual Reality",
  "Campagnolo s.r.l - DTI EPS V3 Interface",
  "Campagnolo s.r.l - EPS V4 INTERNAL INTERFACE",
  "Campagnolo s.r.l - Super Record Wireless Rear Derailer",
  "Cannondale Wheel Sensor",
  "Cardiosport - SOLO Bike Speed \u0026 Cadence Sensors",
  "Cardiosport - TP5+ HEART RATE \u0026 STRIDE SENSOR",
  "Cardiosport ANT+ Bike Combo Sensor",
  "Cardiosport ANT+ Cadence Sensor",
  "Cardiosport ANT+ Shoe Pod",
  "Cardiosport ANT+ Speed Sensor",
  "Cardiosport G2 Heart Rate Transmitter",
  "Cardiosport TP3 Duplex Heart Rate Transmitter",
  "Cardiosport TP3 Heart Rate Transmitter",
  "CATEYE - Avventura",
  "CATEYE - Cadence Sensor",
  "CATEYE - HR-11 Heart Rate Sensor",
  "CATEYE - ISC-11 Speed/Cadence Sensor",
  "CATEYE - OHR-31",
  "CATEYE - Optical Heart Rate Sensor",
  "CATEYE - Speed Sensor",
  "CATEYE - Stealth evo+ CC-GL51",
  "Cerevellum - Hindsight 35",
  "CicloSport - Cadence set ANT+",
  "CicloSport - CM 9.3A / CM 9.3A+",
  "CicloSport - Heart rate set ANT+",
  "CicloSport - Heart rate set textile ANT+",
  "CicloSport - Speed Sensor Set ANT+",
  "CompeGPS - TwoNav Anima+",
  "CompeGPS - TwoNav Sportiva+",
  "CompeGPS - TwoNav Ultra",
  "Concept2 - Dynamic Indoor Rower with PM4",
  "Concept2 - Dynamic Indoor Rower with PM5",
  "Concept2 - Model D with PM4",
  "Concept2 - Model D with PM5",
  "Concept2 - Model E with PM4",
  "Concept2 - Model E with PM5",
  "Concept2 - SkiErg with PM4",
  "Concept2 - SkiErg with PM5",
  "Coospo - Armband Heart Rate Monitor",
  "Coospo - BC 200 GPS Bike Computer",
  "Coospo - BC107",
  "Coospo - Bike Sensor",
  "Coospo - BK8 Speed and Cadence Sensor",
  "Coospo - CS300",
  "Coospo - CS500",
  "Coospo - H808S",
  "Coospo - Heart Rate Monitor Armband",
  "CORE",
  "Core - Body Temperature Monitor Widget - CIQ App",
  "COROS Wearables Inc - APEX",
  "COROS Wearables Inc - APEX PRO",
  "COROS Wearables Inc - COROS PACE 2 Premium GPS Sport Watch",
  "COROS Wearables Inc - PACE",
  "COROS Wearables Inc - VERTIX",
  "cosinuss° GmbH - cosinuss° One",
  "Cosmed - K5",
  "Cosmed - Q-NRG Max",
  "crt_hun - CRTTempeField",
  "crt_hun - CRTTempeWidget",
  "Cyber Motions Power Meter Hub",
  "Cycleops - Magnus",
  "Cycleops - The Hammer",
  "Cycliq Products Ltd - Fly 12CE",
  "Cycliq Products Ltd - Fly6",
  "Cycplus - C3 BIKE SPEED \u0026 CADENCE SENSOR",
  "Decathlon SE - BC900 GPS Cyclometer",
  "Decathlon SE - Domyos Challenge Bike 900",
  "Decathlon SE - HRB 500",
  "Decathlon SE - HRM Belt",
  "Decathlon SE - RUN500",
  "Digifit - Connect",
  "Digifit - Connect Bike Case",
  "Duncan Werner - Fitness Tracker Free",
  "Dyaco International - Johnny G Spirit Bike",
  "Dynamic5 AB - JaBIT",
  "Dyno Velo - Dyno Power Meter",
  "Easton Cycling - Cinch Power Meter Spindle",
  "Echowell Electronic Co., Ltd. - Cadence Sensor/GR10",
  "Echowell Electronic Co., Ltd. - ComboSensor/GTR20 (Speed plus Cadence)",
  "Echowell Electronic Co., Ltd. - Dual Mode Speed/ Cadence Transmitter, DMTR30",
  "Echowell Electronic Co., Ltd. - Heart Rate Sensor/DMH30",
  "Echowell Electronic Co., Ltd. - Heart Rate Sensor/GH10",
  "Echowell Electronic Co., Ltd. - Heart Rate Sensor/GH20",
  "Echowell Electronic Co., Ltd. - LEV100",
  "Echowell Electronic Co., Ltd. - Magnet-less Crank Cadence Sensor",
  "Echowell Electronic Co., Ltd. - Magnet-less Hub Speed Sensor",
  "Echowell Electronic Co., Ltd. - MLR30",
  "Echowell Electronic Co., Ltd. - Speed Sensor/GT10",
  "Echowell Electronic Co., Ltd. - Wireless Cycle Computer/MW10G",
  "Echowell Electronic Co., Ltd. - Wireless Cycle Computer/MW10G_Combo",
  "EDGE PLUS +",
  "Elite srl - Direto",
  "Elite srl - Drivo",
  "Elite srl - Justo",
  "Elite srl - Kura",
  "Elite srl - Qubo Digital Smart B+",
  "Elite srl - Rampa",
  "Elite srl - Real Axiom B+",
  "Elite srl - Real E-motion B+",
  "Elite srl - Real Turbo Muin B+",
  "Elite srl - Realtour B+",
  "Emotion Fitness - Motion Cardio Line 900",
  "Engine Design Group LLC - Mo-Fit® Heart Rate Monitor Chest Strap",
  "EpicRide - VirtualPowerMeter",
  "Epson - SSHRKIT01 Heart Rate Sensor",
  "Epson - WristableGPS SS-500",
  "Epson - WristableGPS SS-700",
  "ErgVideo Inc. - ErgVideo",
  "Everysight Ltd. - RAPTOR+",
  "Ezon - Accurate Heart Rate Belt",
  "F45 Training Pty Ltd - F45 Lionheart",
  "Falco e-motors - Falco eDrive",
  "Falco e-motors - Falco Hxd Wireless ANT+ Console",
  "Falk Outdoor - Pantera Series",
  "Favero Electronics Srl - Assioma Power Meter",
  "Favero Electronics Srl - Assioma PRO MX",
  "Favero Electronics Srl - bePRO",
  "Fazua - RIDE 60 Control Hub",
  "Fazua - RIDE 60 LED Hub",
  "Fitcare - Armband heart rate monitor",
  "Fitcare - Chest Strap Heart Rate Monitor",
  "Fitcare - Cycling Cadence Sensor",
  "Fitcare - GPS Bicycle Computer",
  "Fitcare - GPS Bike Computer",
  "Fitcare - Heart Rate Monitor",
  "Five Mind Creations - PowerBeatsVR",
  "flori314 - S2C - Speed to Cadence",
  "flyingflo - Auxiliary Heart Rate - CIQ APP",
  "Fujitsu - Arrows NX",
  "Fujitsu - Arrows NX F-01J",
  "Fujitsu - Arrows NX F-02H",
  "Fujitsu - Arrows Tab F-04H",
  "Full Speed Ahead (FSA) - FSA E-system Hub Motor",
  "Full Speed Ahead (FSA) - FSA powerBox",
  "Full Speed Ahead (FSA) - K-Force WE",
  "G.Pulse International Co., Ltd - HRM-BLE-300",
  "Garmin - Aera 660",
  "Garmin - aera760",
  "Garmin - Alpha 10",
  "Garmin - Alpha 200",
  "Garmin - Alpha 200i",
  "Garmin - Alpha 300 Series",
  "Garmin - Approach S62",
  "Garmin - Approach S70",
  "Garmin - Astro 430",
  "Garmin - Astro 900",
  "Garmin - Bike Cadence Sensor",
  "Garmin - Bike Speed Sensor",
  "Garmin - Cadence Sensor 2",
  "Garmin - chirp™",
  "Garmin - D2 Air",
  "Garmin - D2 Charlie",
  "Garmin - D2 Mach 1",
  "Garmin - D2™ Pilot Watch",
  "Garmin - Dash Cam 45/55/65W",
  "Garmin - Descent G1",
  "Garmin - Descent G1 Solar",
  "Garmin - Descent MK1",
  "Garmin - Descent Mk2 \u0026 Descent Mk2i",
  "Garmin - Descent MK3 Series",
  "Garmin - DriveTrack 71",
  "Garmin - eBike Remote",
  "Garmin - Edge 1030",
  "Garmin - Edge 1030 Plus",
  "Garmin - Edge 1040",
  "Garmin - Edge 1050",
  "Garmin - Edge 130",
  "Garmin - Edge 130 Plus",
  "Garmin - Edge 520 Plus",
  "Garmin - Edge 530",
  "Garmin - Edge 540 Solar",
  "Garmin - Edge 820",
  "Garmin - Edge 830",
  "Garmin - Edge 840 Solar",
  "Garmin - Edge Explore",
  "Garmin - Edge Explore 2",
  "Garmin - Edge® 1000",
  "Garmin - Edge® 25",
  "Garmin - Edge® 500",
  "Garmin - Edge® 510",
  "Garmin - Edge® 520",
  "Garmin - Edge® 800",
  "Garmin - Edge® 810",
  "Garmin - Edge® Explore 1000",
  "Garmin - Edge® Remote Control",
  "Garmin - Edge® Touring Plus",
  "Garmin - Enduro",
  "Garmin - epix",
  "Garmin - Epix Gen 2",
  "Garmin - epix Pro (Gen 2)",
  "Garmin - eTrex®30",
  "Garmin - eTrex®35",
  "Garmin - fenix 2",
  "Garmin - Fenix 2 Special Edition",
  "Garmin - fenix 3",
  "Garmin - fenix 3 HR",
  "Garmin - Fenix 5",
  "Garmin - Fenix 5 Plus",
  "Garmin - Fenix 5S Plus",
  "Garmin - Fenix 5X Plus",
  "Garmin - Fenix 6",
  "Garmin - Fenix 6 Pro Solar",
  "Garmin - Fenix 6 Solar (EUROPE)",
  "Garmin - Fenix 6S Pro Solar",
  "Garmin - Fenix 6S Solar (EUROPE)",
  "Garmin - Fenix 6X Pro Solar",
  "Garmin - Fenix 7",
  "Garmin - Fenix 7S/7/7X Pro Solar",
  "Garmin - Fenix Chronos",
  "Garmin - fenix™",
  "Garmin - Foot Pod",
  "Garmin - Forerunner 165",
  "Garmin - Forerunner 165 Music",
  "Garmin - Forerunner 245",
  "Garmin - Forerunner 245 Music",
  "Garmin - Forerunner 255",
  "Garmin - Forerunner 265",
  "Garmin - Forerunner 35",
  "Garmin - Forerunner 45",
  "Garmin - Forerunner 45 Plus",
  "Garmin - Forerunner 45S",
  "Garmin - Forerunner 55",
  "Garmin - FORERUNNER 645",
  "Garmin - FORERUNNER 645 Music",
  "Garmin - Forerunner 735XT",
  "Garmin - Forerunner 745",
  "Garmin - Forerunner 935",
  "Garmin - Forerunner 945",
  "Garmin - Forerunner 945 LTE",
  "Garmin - Forerunner 955",
  "Garmin - Forerunner 965",
  "Garmin - Forerunner® 15",
  "Garmin - Forerunner® 210",
  "Garmin - Forerunner® 220",
  "Garmin - Forerunner® 225",
  "Garmin - Forerunner® 230",
  "Garmin - Forerunner® 235",
  "Garmin - Forerunner® 25",
  "Garmin - Forerunner® 310XT",
  "Garmin - Forerunner® 50",
  "Garmin - Forerunner® 610",
  "Garmin - Forerunner® 620",
  "Garmin - Forerunner® 630",
  "Garmin - Forerunner® 910XT",
  "Garmin - Forerunner® 920XT",
  "Garmin - Foretrex 801",
  "Garmin - Foretrex 901 Ballistic Edition",
  "Garmin - FR70",
  "Garmin - G3X Touch Flight Display",
  "Garmin - GPSMAP 65/65s",
  "Garmin - GPSMAP 66sr",
  "Garmin - GPSMAP 66st",
  "Garmin - GPSMap 67",
  "Garmin - GPSMAP® 64s",
  "Garmin - GPSMAP® 64st",
  "Garmin - GPSMAP® 66i",
  "Garmin - GPSMap276",
  "Garmin - GSC™ 10 Speed/Cadence Bike Sensor",
  "Garmin - HRM - Fit",
  "Garmin - HRM-Dual",
  "Garmin - HRM-PRO",
  "Garmin - HRM-Pro Plus",
  "Garmin - HRM-Run",
  "Garmin - HRM-Run™",
  "Garmin - HRM-Swim",
  "Garmin - HRM-Tri™",
  "Garmin - Instinct",
  "Garmin - Instinct 2",
  "Garmin - Instinct 2X Solar",
  "Garmin - Instinct Crossover",
  "Garmin - Instinct Solar",
  "Garmin - Lily 2 Active",
  "Garmin - Marq 2",
  "Garmin - Marq Generation 2 Series",
  "Garmin - Marq Series",
  "Garmin - Montana 700 / 700i / 750i",
  "Garmin - Monterra™",
  "Garmin - Oregon 700",
  "Garmin - Oregon 750",
  "Garmin - Overlander",
  "Garmin - PRO 550 Plus",
  "Garmin - Quatix 5",
  "Garmin - quatix 5 Sapphire",
  "Garmin - Quatix 6",
  "Garmin - Rally™ RS100",
  "Garmin - Rally™ RS200",
  "Garmin - Rino 750",
  "Garmin - Rino 755t",
  "Garmin - Running Dynamics Pod",
  "Garmin - Speed Sensor 2",
  "Garmin - Swim 2",
  "Garmin - tactix 7",
  "Garmin - tactix Charlie",
  "Garmin - Tactix Delta",
  "Garmin - tactix® Bravo",
  "Garmin - tactix™",
  "Garmin - Tacx Neo 3M Smart trainer",
  "Garmin - Tacx NEO Bike Plus",
  "Garmin - tempe™ Wireless Temperature Sensor",
  "Garmin - Tread Xl - Baha Chase",
  "Garmin - USB ANT Stick™",
  "Garmin - Varia eRTL615",
  "Garmin - Varia RCT715",
  "Garmin - Varia RTL510/RTL511",
  "Garmin - Varia RTL515",
  "Garmin - Varia RVR315",
  "Garmin - Varia UT800",
  "Garmin - Varia Vision™ In-sight Display",
  "Garmin - Varia™ Bike Radar Head Unit",
  "Garmin - Varia™ Head Light",
  "Garmin - Varia™ Rearview Radar",
  "Garmin - Varia™ Remote",
  "Garmin - Varia™ Tail Light",
  "Garmin - Vector 3",
  "Garmin - Vector™",
  "Garmin - Vector™ 2",
  "Garmin - Vector™ S",
  "Garmin - Venu",
  "Garmin - Venu 2",
  "Garmin - Venu 2 Plus",
  "Garmin - Venu 2s",
  "Garmin - Venu 3/3s",
  "Garmin - Venu Sq",
  "Garmin - Venu Sq 2",
  "Garmin - Venu Sq Music",
  "Garmin - virb 360",
  "Garmin - VIRB Ultra 30",
  "Garmin - Virb® X,Virb® XE",
  "Garmin - VIRB™ Elite",
  "Garmin - VIRB™ Remote Control",
  "Garmin - Vivoactive 3",
  "Garmin - Vivoactive 3 Music",
  "Garmin - Vivoactive 3 Music LTE",
  "Garmin - Vivoactive 4",
  "Garmin - Vivoactive 5",
  "Garmin - vivoactive HR",
  "Garmin - vivoactive™",
  "Garmin - vivofit 3",
  "Garmin - vivofit® 2",
  "Garmin - vivofit™",
  "Garmin - Vivomove 3",
  "Garmin - Vivomove HR",
  "Garmin - Vivomove Sport",
  "Garmin - Vivomove Trend",
  "Garmin - vivosmart 3",
  "Garmin - Vivosmart 4",
  "Garmin - Vivosmart 5",
  "Garmin - vivosmart HR+",
  "Garmin - vivosmart® HR",
  "Garmin - vivosmart™",
  "Garmin - Vivosport",
  "Garmin - zūmo 395LM",
  "Garmin - zūmo® 590LM",
  "Garmin ANT+™ adapter for iPhone®",
  "Garmin Fit™ (Android)",
  "Garmin Fit™ (iOS)",
  "Garmin Heart Rate Monitor",
  "Garmin Soft Strap Premium Heart Rate Monitor",
  "Gavriel - Smart HRM",
  "Geoid - HS800 Optical Armband Heart Rate Monitor",
  "GEOID CC500 Smart GPS Bike Computer",
  "GEOID CC600 Smart GPS Bike Computer",
  "Geoid GPS Bike Computer",
  "Geonaute - HW Digital Coded Belt",
  "Geonaute - Keymaze Quechua 700 Trail",
  "Geonaute - ONmiles Pod",
  "Geonaute - ONmove 500 GPS Watch",
  "Geonaute - ONmove 700 GPS Watch",
  "Giant - Alarm RideSense Sensor",
  "Giant - CY24 Recon HL1400",
  "Giant - CycloSmart",
  "Giant - Neos Endless",
  "Giant - PLANET G9 SMART COMPUTER",
  "Giant - Power Pro",
  "Giant - Recon HL 1600 Headlight",
  "Giant - RECON PLUS 150",
  "Giant - Recon Plus HL2600",
  "Giant - Recon Plus TL300",
  "Giant - Ride Control One",
  "Giant - RideSense Sensor",
  "goji - Heart Rate Belt",
  "Hammerhead Navigation Inc - Hammerhead Karoo",
  "Hammerhead Navigation Inc - Karoo 2",
  "HEALTH \u0026 LIFE CO., LTD. - FitSignal Data Transfer Device HL301",
  "HEALTH \u0026 LIFE CO., LTD. - FitSignal Heart Rate Monitor HL300",
  "HEALTH \u0026 LIFE CO., LTD. - FitSignal Sport Watch HL310",
  "HMM - smartLAB scale W",
  "HMM - smartLAB®fit+",
  "Holux - ANT+ Bike Cadence Sensor",
  "Holux - ANT+ Bike Speed Sensor",
  "Holux - FunTrek 130 Pro",
  "Holux - GPSport 260 Pro",
  "Holux ANT+ Heart Rate Monitor",
  "HTC Desire® EYE",
  "HTC Rhyme",
  "Humon CIQ App",
  "Hydrow Rower",
  "iBike ANT+ Heart Rate Strap",
  "iBike ANT+ Speed Sensor",
  "iBike Combined Speed \u0026 Cadence Sensor Model BKM4G",
  "iBike HRMIB Heart Rate Strap",
  "iBike HRMIG Heart Rate Strap",
  "iBike Wireless Cadence Sensor Model BKM3",
  "iBike Wireless Speed Sensor Model BKM3",
  "iGPSPORT - BSC 200",
  "iGPSPORT - BSC100S Bike Computer",
  "iGPSPORT - C61",
  "iGPSPORT - HR 70 Heart Rate Monitor",
  "iGPSPORT - HR35",
  "iGPSPORT - HR40",
  "iGPSPORT - HR60",
  "iGPSPORT - iGS10",
  "iGPSPORT - iGS10S",
  "iGPSPORT - iGS320",
  "iGPSPORT - iGS50E GPS Cycling Computer",
  "iGPSPORT - iGS50S",
  "iGPSPORT - iGS520 GPS CYCLING COMPUTER",
  "iGPSPORT - iGS60",
  "iGPSPORT - iGS618 GPS Cycling Computer",
  "iGPSPORT - iGS620",
  "iGPSPORT - iGS630 GPS BIKE COMPUTER",
  "iGPSPORT - iGS800",
  "iGPSPORT - SPD61",
  "Indoorcycling Group GmbH - IC7 Computer",
  "Indoorcycling Group GmbH - LCD Coach-By-Color Connect Computer for IC5",
  "Indoorcycling Group GmbH - Wattrate TFT Computer for IC6 \u0026 IC7",
  "InigoTE - alphaHRV - CIQ APP",
  "INPEAK POWERCRANK",
  "IT4Cycling - Cycling Test \u0026 Training Software",
  "iTravel-Tech - MW Watch",
  "Ivercellino - Sonja Speed Spinning Datafield - CIQ APP",
  "Jepster",
  "Jet Black - CX-320",
  "Jet Black - JB Heart Rate Monitor",
  "Jet Black - WhisperDrive Smart",
  "Jet Black - WhisperDRIVE Speed Sensor",
  "Jorgillu - RunScribe for Fenix 7/Epix 2",
  "Keiser - M3i Studio Indoor Bike",
  "Kettler - HOI SPEED, HOI FRAME, HOI FRAME+",
  "Kettler - World Tours 3.0",
  "Kinetic by Kurt - Kinetic inRide 3.0",
  "Kinetic by Kurt - Kinetic Magnet-less Speed or Cadence Sensor",
  "Kinetic by Kurt - Kinetic RS Power Bike Trainer",
  "Kinetic Sports Technologies Limited - Kinetic inRide H1 Heart Rate Monitor",
  "Kopin Corporation - Solos",
  "Kopin Corporation - Solos: Kickstarter Edition",
  "Kurev CIQ App",
  "Kyocera Corporation - DuraForce PRO 3",
  "Kyocera Corporation - Durasport 5G",
  "Kyocera Corporation - Torque 5G",
  "Kyocera Corporation - Torque G06",
  "Kyocera Corporation - TORQUE® G04",
  "Kyto Fitness Technology - KYTO 2809",
  "Kyto Fitness Technology - KYTO2540",
  "Leikr GPS Sports Watch",
  "Leomo - Type-R",
  "LEOMO TYPE-S",
  "LEV+ E-Bike Display",
  "Lezyne - Mega XL GPS",
  "Lezyne - Super Pro GPS",
  "LifeBEAM - Smart Helmet",
  "LifeBEAM Smart Hat",
  "LifeTrak - ZoomHRV",
  "LIMITS Technology - LIMITS Power Meter",
  "Look Cycle International - KEO Power Dual Mode",
  "Look Cycle International - Look Power",
  "maca88 - CIQ APP - E-Bike Edge MultiField",
  "maca88 - Tempe Field",
  "Magellan - Switch",
  "Magellan - Switch Up",
  "Magellan Cyclo 315 and 315hc",
  "Magellan Cyclo 505 and 505hc",
  "Magellan Heart Rate Monitor (Soft Strap)",
  "Magellan Speed/Cadence Sensor",
  "Magene Technology Co. Ltd - AT Series Smart Bike Headlight",
  "Magene Technology Co. Ltd - C206 Series GPS Smart Bike Computer",
  "Magene Technology Co. Ltd - C406 Pro GPS Bike Computer",
  "Magene Technology Co. Ltd - C416 GPS Smart Computer",
  "Magene Technology Co. Ltd - C506 Smart GPS Bike Computer",
  "Magene Technology Co. Ltd - C606 GPS Smart Computer",
  "Magene Technology Co. Ltd - Gemini 210",
  "Magene Technology Co. Ltd - GRAVAT",
  "Magene Technology Co. Ltd - H003",
  "Magene Technology Co. Ltd - H303",
  "Magene Technology Co. Ltd - H603 Heart Rate Monitor",
  "Magene Technology Co. Ltd - H803 Heart Rate Armband",
  "Magene Technology Co. Ltd - L508 Radar Tail Light",
  "Magene Technology Co. Ltd - Mover",
  "Magene Technology Co. Ltd - P325 CS",
  "Magene Technology Co. Ltd - P505",
  "Magene Technology Co. Ltd - P705 Bicycle Pedal Power Meter",
  "Magene Technology Co. Ltd - QED Electronic Shifting System",
  "Magene Technology Co. Ltd - QED Road Bike Crankset",
  "Magene Technology Co. Ltd - S314 Cycling Speed and Cadence Sensor",
  "Magene Technology Co. Ltd - SHS (Speed Hub Sensor)",
  "Magene Technology Co. Ltd - Smart GPS Bike Computer",
  "Magene Technology Co. Ltd - Smart Trainer",
  "Magene Technology Co. Ltd - T100 Power Bike Trainer",
  "Magene Technology Co. Ltd - T200 Full Function Smart Trainer",
  "Magene Technology Co. Ltd - T300 Smart Trainer",
  "Magene Technology Co. Ltd - T600 Smart Power Trainer",
  "MAGICSHINE - SEEMEE R300",
  "Magura - eLECT Dropper Seatpost",
  "Magura - eLECT Suspension Fork",
  "Magura - eLECT Suspension Rear Shock",
  "Magura Remote",
  "MAHLE SMARTBIKE SYSTEM S.L.U. - HUS",
  "MAHLE SMARTBIKE SYSTEM S.L.U. - MAHLE Ebikemotion SLU - X35+",
  "MAHLE SMARTBIKE SYSTEM S.L.U. - PulsarONE",
  "MAHLE SMARTBIKE SYSTEM S.L.U. - XS - System",
  "Manta5 - CIQ App - Manta5 HUD",
  "Matrix - CXP Target Training Cycle",
  "MaximumTrainer®",
  "maxon motor ag - BIKEDRIVE AIR Interface",
  "Mentech - Avant 700",
  "Mi Pulse HRM",
  "MIO Global - Mio FUSE",
  "MIO Global - Mio LINK",
  "MIO Global - Mio VELO",
  "Mio Technology - Cyclo 205",
  "Mio Technology - Cyclo 405",
  "Mio Technology - Cyclo 605",
  "Mio Technology - Mio Cyclo 105",
  "Mio Technology - Mio Cyclo 305",
  "Mio Technology - Mio Cyclo 315 and 315hc",
  "Mio Technology - Mio Cyclo 505",
  "Mobii Heart Rate Monitor",
  "Monark Exercise - Novo",
  "Monark Exercise - Novo Mini",
  "Motorola - MOTOACTV™",
  "Motorola - MOTOACTV™ Golf Edition",
  "Motorola - MOTOACTV™ Heart Rate Monitor Chest Strap",
  "Motorola Bike Speed \u0026 Cadence Sensor",
  "MOXY - Steve Neal Moxy Lap Data Field - CIQ APP",
  "Moxy 5-1-5 Cycling Assesment",
  "Moxy 5-1-5 Running Assessment",
  "Moxy Data Field - Edge version 0.3",
  "Moxy Data Field - Epix",
  "Moxy Data Field - Fenix 3",
  "Moxy Data Field - Forerunner 230/235/630/735",
  "Moxy Data Field - FR920XT",
  "Moxy Data Field - vivoactive",
  "Moxy Data Field for Vivoactive HR",
  "MOXY Muscle Oxygen Monitor",
  "MoxyCycle ConnectIQ App",
  "MoxyRun ConnectIQ App",
  "MY TACX APP",
  "Myzone - MZ-3",
  "Myzone - MZ-Switch Heart Rate Monitor",
  "Nikeow - Swim Notes - CIQ App",
  "NiteRider - Bike Cadence Sensor",
  "NiteRider - Bike Speed Sensor",
  "NiteRider Heart Rate Monitor",
  "Nokia 8",
  "Nokia 8 Sirocco",
  "Nokia 9 Pureview",
  "North Pole Engineering - CABLE",
  "North Pole Engineering - Runn",
  "North Pole Engineering - Runn Incline Data Field - CIQ App",
  "North Pole Engineering - WASP / ANT to WiFi Bridge",
  "North Pole Engineering - WASP-POE",
  "Notio Technologies Inc. - NotioKonect",
  "NTT docomo - Fujitsu Arrows NX F-02G",
  "NTT docomo - Fujitsu Arrows NX F-04G",
  "Nurvv Ltd",
  "Oakley - Radar Pace",
  "Octane Fitness - LateralX Touch LX8000",
  "Octane Fitness - PRO3700TOUCH",
  "Octane Fitness - PRO4700TOUCH",
  "Octane Fitness - Q37xi",
  "Octane Fitness - Q47xi",
  "Octane Fitness - XR6000 TOUCH",
  "Oleksiy - AeroPod CdA - CIQ APP",
  "Oleksiy - SmO2 Graph DataField",
  "One Giant Leap - Kayak Power Meter",
  "ONYER Tech - ONYER",
  "Orange Theory Fitness - OTBeat Burn",
  "o-synce - ANT+remote",
  "o-synce - Coachsmart",
  "o-synce - Coachsmart LEV",
  "o-synce - heart 2feel x",
  "o-synce - macro2sx cad",
  "o-synce - macro2sx com",
  "o-synce - macro2sx speed",
  "o-synce - maxrun",
  "o-synce - navi2coach",
  "o-synce - screeneye x",
  "o-synce - USEE",
  "Outside Interactive - Virtual Runner (iPAD app)",
  "Outside Interactive - Virtual Runner (Windows Software)",
  "PAPAGO! - GOLiFE Care Smart Band",
  "PAPAGO! - GOLiFE GoWatch X-PRO",
  "PAPAGO! - GoWatch 820i",
  "PAPAGO! GoHeart 100 Heart Rate Monitor",
  "PAPAGO! GOLiFE Heart",
  "PAPAGO! GOLiFE RUN 120+",
  "PAPAGO! GoRide100 Speed \u0026 Cadence Combo",
  "PAPAGO! GoWatch770",
  "Peloton Bike",
  "Peloton Bike+",
  "PerfPRO Studio",
  "PeriPedal",
  "Peter Decker - Tempe Visualizer",
  "Pioneer - Cyclocomputer SGX-CA500",
  "Pioneer - Cyclocomputer SGX-CA900",
  "Pioneer - GPS computer- SGX-CA600",
  "Pioneer - Pedal Monitoring Sensor SGY-PM910HL/SGY-PM910HR",
  "Pioneer - Pedaling Monitor Sensor",
  "Pioneer - Pedaling Monitor Sensor SGY-PM900H79",
  "Pioneer - Pedaling Monitor Sensor SGY-PM900H90",
  "Pioneer - Pedaling Monitor Sensor SGY-PM910H",
  "Pioneer - PotterNavi SGX-CN700-w/-k",
  "Pioneer - PotterNavi SGX-CN710-w/-k",
  "Pioneer - SGY-CS500 ANT+ Speed and Cadence Sensors",
  "Pioneer - SGY-HR500 ANT+ Heart Rate Monitor",
  "Polar Electro Oy - Polar H10",
  "Polar Electro Oy - Polar H9",
  "Polar Electro Oy - Polar OH1",
  "Polar Electro Oy - POLAR VERITY SENSE",
  "PowerTap / CycleOps - C1 Chainring",
  "PowerTap / CycleOps - Coded Heart Rate Strap",
  "PowerTap / CycleOps - Joule",
  "PowerTap / CycleOps - Joule GPS",
  "PowerTap / CycleOps - PowerCal",
  "PowerTap / CycleOps - PowerTap ELITE+ Hub",
  "PowerTap / CycleOps - PowerTap G3 Hub",
  "PowerTap / CycleOps - PowerTap G3C Hub",
  "PowerTap / CycleOps - PowerTap P1 Pedals",
  "PowerTap / CycleOps - PowerTap PRO Hub",
  "PowerTap / CycleOps - PowerTap Pro MTB Disc Hub",
  "PowerTap / CycleOps - PowerTap Pro MTB Hub",
  "PowerTap / CycleOps - PowerTap PRO Track Hub",
  "PowerTap / CycleOps - PowerTap Pro+ Hub",
  "PowerTap / CycleOps - PowerTap SL+ Hub",
  "PowerTap / CycleOps - PowerTap SLC+ Hub",
  "PowerTap / CycleOps - Speed \u0026 Cadence Sensor",
  "PowerTap / CycleOps - Speed/Cadence Wireless Sensor",
  "PRECOR - Spinner Chrono Console",
  "PRO - SCIO Alti ANT+",
  "PRO - SCIO ANT+",
  "PROZIS.COM S.A - sCore",
  "PROZIS.COM S.A - VeloX - Cycling Speed and Cadence Sensor",
  "Pulse Monitor 1.x",
  "Qingdao Geoid Intelligence Technology Co., Ltd - CS600",
  "Qingdao Geoid Intelligence Technology Co., Ltd - HS500",
  "Quarq - CinQo Saturn FSA Team Issue",
  "Quarq - CinQo Saturn Lightning Carbon",
  "Quarq - CinQo Saturn Specialized FACT",
  "Quarq - CinQo Saturn SRAM S900",
  "Quarq - CinQo Saturn2 for Cannondale",
  "Quarq - CinQo Saturn2 for Specialized",
  "Quarq - DFour",
  "Quarq - DZero",
  "Quarq - FSA SL-K Light Quarq Power Meter",
  "Quarq - PowerTap P2 Pedals",
  "Quarq - Rotor 3D Quarq Power Meter",
  "Quarq - SRAM RED 2012 Quarq Power Meter",
  "Quarq - SRAM RED 22",
  "Quarq - SRAM S2275 MTB Power Meter",
  "QUARQ ELSA R",
  "QUARQ ELSA RS",
  "QUARQ FOR CANNONDALE",
  "QUARQ FOR SPECIALIZED",
  "QUARQ RIKEN R",
  "Rainer Blind - a Training Tracker",
  "RAVEMEN - FR300",
  "RAVEMEN - NT201",
  "Recon Instruments - Recon Jet",
  "Rogue Fitness - ROGUE Echo Rower",
  "ROTOR Bike Components - 2INPOWER",
  "ROTOR Bike Components - INpower",
  "ROTOR Bike Components - INpower DM",
  "ROTOR Bike Components - INSPIDER",
  "ROTOR Bike Components - INspider MTB",
  "ROTOR Bike Components - ROTOR Power",
  "S+H Technology S.A. - SPH Cycling",
  "Samsung Electronics Co., Ltd. - G9198 / Collar World Flagship III",
  "Samsung Electronics Co., Ltd. - GALAXY A3",
  "Samsung Electronics Co., Ltd. - Galaxy A3 (2016)",
  "Samsung Electronics Co., Ltd. - Galaxy A3 (2017)",
  "Samsung Electronics Co., Ltd. - GALAXY A5",
  "Samsung Electronics Co., Ltd. - Galaxy A5 (2016)",
  "Samsung Electronics Co., Ltd. - Galaxy A50",
  "Samsung Electronics Co., Ltd. - Galaxy A51",
  "Samsung Electronics Co., Ltd. - GALAXY A7",
  "Samsung Electronics Co., Ltd. - Galaxy A7 (2016)",
  "Samsung Electronics Co., Ltd. - Galaxy A70",
  "Samsung Electronics Co., Ltd. - GALAXY A8",
  "Samsung Electronics Co., Ltd. - Galaxy A8 (2018)",
  "Samsung Electronics Co., Ltd. - Galaxy A80",
  "Samsung Electronics Co., Ltd. - Galaxy A9 (2016)",
  "Samsung Electronics Co., Ltd. - Galaxy A90",
  "Samsung Electronics Co., Ltd. - GALAXY Alpha",
  "Samsung Electronics Co., Ltd. - GALAXY Avant™",
  "Samsung Electronics Co., Ltd. - Galaxy C",
  "Samsung Electronics Co., Ltd. - GALAXY CORE Max",
  "Samsung Electronics Co., Ltd. - GALAXY CORE Prime",
  "Samsung Electronics Co., Ltd. - GALAXY E5",
  "Samsung Electronics Co., Ltd. - GALAXY E7",
  "Samsung Electronics Co., Ltd. - Galaxy Fold",
  "Samsung Electronics Co., Ltd. - GALAXY Golden 2 双网/双待W2015",
  "Samsung Electronics Co., Ltd. - GALAXY Grand 2 (LTE)",
  "Samsung Electronics Co., Ltd. - GALAXY Grand 3 Duos",
  "Samsung Electronics Co., Ltd. - GALAXY Grand Max",
  "Samsung Electronics Co., Ltd. - GALAXY Grand Prime",
  "Samsung Electronics Co., Ltd. - GALAXY J",
  "Samsung Electronics Co., Ltd. - GALAXY J5",
  "Samsung Electronics Co., Ltd. - Galaxy J5x",
  "Samsung Electronics Co., Ltd. - GALAXY J7",
  "Samsung Electronics Co., Ltd. - Galaxy J7 (2017)",
  "Samsung Electronics Co., Ltd. - Galaxy J7 2016 (CMCC)",
  "Samsung Electronics Co., Ltd. - Galaxy J7 2016 (CTC)",
  "Samsung Electronics Co., Ltd. - Galaxy J7x",
  "Samsung Electronics Co., Ltd. - GALAXY Mega2",
  "Samsung Electronics Co., Ltd. - Galaxy Note 10",
  "Samsung Electronics Co., Ltd. - GALAXY Note 10.1 (2014 Edition)",
  "Samsung Electronics Co., Ltd. - GALAXY Note 3",
  "Samsung Electronics Co., Ltd. - GALAXY Note 3 Lite",
  "Samsung Electronics Co., Ltd. - GALAXY Note 3 Neo",
  "Samsung Electronics Co., Ltd. - GALAXY Note 4",
  "Samsung Electronics Co., Ltd. - GALAXY Note 5",
  "Samsung Electronics Co., Ltd. - Galaxy Note7 - Verizon",
  "Samsung Electronics Co., Ltd. - Galaxy Note7 (Grace EUR)",
  "Samsung Electronics Co., Ltd. - Galaxy Note8 Open",
  "Samsung Electronics Co., Ltd. - Galaxy Note9 (EUROPE)",
  "Samsung Electronics Co., Ltd. - Galaxy Note9 (USA)",
  "Samsung Electronics Co., Ltd. - GALAXY NotePRO 12.2",
  "Samsung Electronics Co., Ltd. - Galaxy On7 (2016)",
  "Samsung Electronics Co., Ltd. - Galaxy S10 (EUR)",
  "Samsung Electronics Co., Ltd. - Galaxy S10 (USA)",
  "Samsung Electronics Co., Ltd. - Galaxy S20 Series (EUR)",
  "Samsung Electronics Co., Ltd. - Galaxy S20 Series (USA)",
  "Samsung Electronics Co., Ltd. - GALAXY S4 (Android 4.3 and up)",
  "Samsung Electronics Co., Ltd. - GALAXY S5",
  "Samsung Electronics Co., Ltd. - GALAXY S5 ACTIVE",
  "Samsung Electronics Co., Ltd. - GALAXY S5 Neo",
  "Samsung Electronics Co., Ltd. - GALAXY S5 SPORT",
  "Samsung Electronics Co., Ltd. - GALAXY S5 광대역LTE-A",
  "Samsung Electronics Co., Ltd. - GALAXY S6 Edge +",
  "Samsung Electronics Co., Ltd. - GALAXY S6/ S6 edge",
  "Samsung Electronics Co., Ltd. - Galaxy S7",
  "Samsung Electronics Co., Ltd. - Galaxy S7 edge",
  "Samsung Electronics Co., Ltd. - Galaxy S8",
  "Samsung Electronics Co., Ltd. - Galaxy S9 (Europe)",
  "Samsung Electronics Co., Ltd. - Galaxy S9 (USA)",
  "Samsung Electronics Co., Ltd. - Galaxy TAB 4 Advanced",
  "Samsung Electronics Co., Ltd. - Galaxy Tab A",
  "Samsung Electronics Co., Ltd. - Galaxy Tab A 2016",
  "Samsung Electronics Co., Ltd. - Galaxy Tab A 8.4",
  "Samsung Electronics Co., Ltd. - GALAXY Tab Active",
  "Samsung Electronics Co., Ltd. - GALAXY Tab A-S LTE",
  "Samsung Electronics Co., Ltd. - GALAXY Tab S 10.5-inch",
  "Samsung Electronics Co., Ltd. - GALAXY Tab S 8.4-inch",
  "Samsung Electronics Co., Ltd. - GALAXY Tab S2",
  "Samsung Electronics Co., Ltd. - Galaxy Tab S3 (LTE)",
  "Samsung Electronics Co., Ltd. - GALAXY Tab4 10.1",
  "Samsung Electronics Co., Ltd. - GALAXY Tab4 7.0",
  "Samsung Electronics Co., Ltd. - GALAXY Tab4 8.0",
  "Samsung Electronics Co., Ltd. - GALAXY TabPRO 10.1",
  "Samsung Electronics Co., Ltd. - GALAXY TabPRO 12.2",
  "Samsung Electronics Co., Ltd. - GALAXY TabPRO 8.4",
  "Samsung Electronics Co., Ltd. - GALAXY TabQ",
  "Samsung Electronics Co., Ltd. - Galaxy TAB-S2 9.7",
  "Samsung Electronics Co., Ltd. - GALAXY View",
  "Samsung Electronics Co., Ltd. - GALAXY W",
  "Samsung Electronics Co., Ltd. - Galaxy Xcover FieldPro",
  "Samsung Electronics Co., Ltd. - Galaxy Z Flip",
  "Samsung Electronics Co., Ltd. - Samsung Galaxy A71",
  "Samsung Electronics Co., Ltd. - Samsung S Health App",
  "Samsung Electronics Co., Ltd. - W2016",
  "Samsung Electronics Co., Ltd. - 三星大器Ⅲ G9092",
  "Samsung Electronics Co., Ltd. - 双卡双待 G9098",
  "Saxonar power2max - power2max MTB ROTOR 3D (multiple chain ring versions)",
  "Saxonar power2max - power2max MTB ROTOR 3D PLUS (multiple chain ring versions)",
  "Saxonar power2max - power2max NG",
  "Saxonar power2max - power2max NGeco",
  "Saxonar power2max - power2max road BOR RR666 (BCD 110 or 130)",
  "Saxonar power2max - power2max road Lightning (BCD 110 or 130)",
  "Saxonar power2max - power2max road ROTOR 3D (BCD 110 or 130)",
  "Saxonar power2max - power2max road ROTOR 3D PLUS (BCD 110 or 130)",
  "Saxonar power2max - power2max road SRAM S900 (BCD 110 or 130)",
  "Saxonar power2max - power2max road TA Carmina (BCD110 or 130)",
  "Saxonar power2max - power2max road TA Vega (BCD 110 or 130)",
  "Saxonar power2max - power2max road Tune Smart Foot (BCD 110 or 130)",
  "Saxonar power2max - power2max road Tune Smart Foot W (BCD 110 or 130)",
  "Saxonar power2max - power2max ROTOR Agilis (BCD 110 or 130)",
  "Schwinn - Cadence Pro™ Console",
  "Schwinn - Mpower Echelon2 Console",
  "Schwinn - MPower™ Console V2",
  "Schwinn - MPower™ Echelon Console",
  "Schwinn - MPower™ Power Upgrade",
  "Schwinn - Z Console",
  "Scosche - RHYTHM + Heart Rate Monitor",
  "Scosche - RHYTHM 24",
  "Scosche - Rhythm+2.0",
  "Seego (Realtrack Systems) - Seego System",
  "Selfloops - Group Fitness Premium",
  "Selfloops Android ANT+ Accessory",
  "Selfloops Group Fitness Plus",
  "Sharp - Aquos Zeta SH-04F",
  "Shenzhen Chileaf Electronics - Armband Heart Rate Monitor",
  "Shenzhen Chileaf Electronics - Chest Strap Heart Rate Monitor",
  "Shimano - CM-1000 Sport Camera",
  "Shimano - CM-1100",
  "Shimano - CM-2000",
  "Shimano - Crankset with Power Meter",
  "Shimano - DURA-ACE Dual Side Power Meter Hollow Tech II Crankset",
  "SHO-U - Ranger Watch W-10",
  "SIGEYI Technology - AXO Power Meter",
  "SIGMA SPORT - EOX View 700",
  "SIGMA SPORT - EOX® VIEW 1300",
  "SIGMA SPORT - iD.Free",
  "SIGMA SPORT - iD.TRI",
  "SIGMA SPORT - R1 Duo",
  "SIGMA SPORT - R2 DUO Combo",
  "SIGMA SPORT - ROX 11.1 EVO",
  "SIGMA SPORT - Rox 12.0 Sport",
  "SIGMA SPORT - ROX 12.1 EVO",
  "SIGMA SPORT - ROX 2.0",
  "SIGMA SPORT - ROX 4.0",
  "SIGMA SPORT - ROX® GPS 10.0",
  "SIGMA SPORT - ROX® GPS 11.0",
  "SIGMA SPORT - Sigma ANT+ Cadence Transmitter",
  "SIGMA SPORT - Sigma ANT+ Speed Transmitter",
  "SIGMA SPORT - Sigma R1 ANT+ Heart Rate Transmitter",
  "Siliconcoach Ltd - Avanti Plus Dynamic Bike Fitting Software",
  "Siliconcoach Ltd - Dialed In Motion Cycling Software",
  "Sony Mobile - Live with Walkman™",
  "SoundOfMotion - VeloComputer Smart Sensor",
  "Specialized - Bike Speed/Cadence Monitor",
  "Specialized - Data Field - Edge 1000",
  "Specialized - Data Field - Edge 520",
  "Specialized - Data Field - Edge 820",
  "Specialized - Heart Rate Sensor",
  "Specialized - SBC-D07",
  "Specialized - Speedzone ANT+ Digital COMP Computer",
  "Specialized - S-Works Power Crank",
  "Specialized - Turbo Vado SL 2 6.0 Carbon",
  "Specialized BG Fit ANT+ Capture Software",
  "SPH Graph",
  "Spinning - Studio Computer",
  "Spivi ANT+ Cadence Sensor",
  "Spivi® Home Edition",
  "SportsTrackLive - SportsTracker by STL (Android)",
  "SportsTrackLive - SportsTracker PRO by STL (Android)",
  "SRAM - Bridge Display",
  "SRAM - Eagle AXS",
  "SRAM - eTap AXS",
  "SRAM - GX Eagle Transmission Derailleur",
  "SRAM - Pike Ultimate Flight Attendant",
  "SRAM - RED AXS Rear Derailleur",
  "SRAM - RED eTAP Rear Derailer",
  "SRAM - Reverb AXS",
  "SRAM - S975 Quarq™ Power Meter",
  "SRAM - XX1 Power Meter",
  "SRAM RED 22 Quarq Power Meter",
  "SRAM RIVAL AXS POWER METER",
  "SRM - Exakt",
  "SRM - MTB PowerMeter Cannondale Triple",
  "SRM - MTB PowerMeter FSA Afterburner",
  "SRM - MTB PowerMeter FSA K-Force light Triple",
  "SRM - MTB PowerMeter Tune Smart Foot Triple",
  "SRM - PowerMeter 6",
  "SRM - PowerMeter BOR RR 688 Standard",
  "SRM - PowerMeter Cannondale Compact",
  "SRM - PowerMeter Cannondale Standard",
  "SRM - PowerMeter FSA Gossamer Compact",
  "SRM - PowerMeter FSA Gossamer Standard",
  "SRM - PowerMeter FSA K-Force Light Compact",
  "SRM - PowerMeter FSA K-Force Light Standard",
  "SRM - PowerMeter Handbike",
  "SRM - PowerMeter Rotor 3D Standard",
  "SRM - PowerMeter Rotor 3D+ Compact",
  "SRM - PowerMeter Rotor 3D+ Standard",
  "SRM - PowerMeter Sailing",
  "SRM - PowerMeter Shimano 7800 Standard",
  "SRM - PowerMeter Shimano 7900 Standard",
  "SRM - PowerMeter Shimano 7950 Compact",
  "SRM - PowerMeter Shimano DuraAce 7800 Compatible Compact",
  "SRM - PowerMeter Specialized Compact",
  "SRM - PowerMeter Specialized Standard",
  "SRM - PowerMeter SRAM S975 Compact (GXP or BB30)",
  "SRM - PowerMeter SRAM S975 Standard (GXP or BB30)",
  "SRM - PowerMeter SRM Science",
  "SRM - PowerMeter Track",
  "SRM - PowerMeter Tune Smart Foot Compact",
  "SRM - PowerMeter Tune Smart Foot Standard",
  "SRM HR",
  "SRM Speed Pod",
  "Stages Cycling - Dash M50/L50",
  "Stages Cycling - Heart Rate Sensor",
  "Stages Cycling - Indoor Cycling Console",
  "Stages Cycling - Power Meter 3.0",
  "Stages Cycling - Stages Dash",
  "Stages Cycling - Stages Dash M200 GPS Bike Computer",
  "Stages Cycling - Stages Indoor Power Meter",
  "Stages Cycling - Stages Power™ Meter",
  "Star Trac - Spinner® Blade ION™ Computer",
  "Star Trac - Spinning® Computer",
  "Star Trac Group Cycling Computer",
  "Stryd Power Meter",
  "Sunlighten - Running Sensor",
  "Sunlighten Heart Rate Monitor",
  "SunnyFit - Bike Cadence – CB110",
  "SunnyFit - Heart Rate Monitor - HR200",
  "SUUNTO - ANT+/BLE Combo Sensor",
  "Suunto Ambit",
  "Suunto Ambit2",
  "Suunto Ambit2 S",
  "Swissmed Mobile - MedM Health app",
  "SZ DJI TECHNOLOGY - DJI Avinox Display",
  "Tacx - ANT+ Dongle micro USB T2090",
  "Tacx - Bushido Smart T2780",
  "Tacx - Flow Smart",
  "Tacx - FLUX 2 Smart",
  "Tacx - FLUX S Smart",
  "Tacx - Genius Smart",
  "Tacx - Heart Rate Belt Smart T1994",
  "Tacx - Magnum",
  "Tacx - NEO 2 Smart",
  "Tacx - NEO Bike Smart",
  "Tacx - Neo Smart",
  "Tacx - Satori Smart T2400",
  "Tacx - T2015 Speed \u0026 Cadence Sensor",
  "Tacx - Uno Smart",
  "Tacx - Vortex Smart T2180",
  "Tacx Cycling App",
  "Takura87 - CIQ APP - ANT+ Power Meter",
  "Takura87 - CIQ APP - Third ANT+ Power Meter",
  "Tanita - BC-1000 (BK/-WH) ANT+ Radio Wireless Body Composition Monitor",
  "Tanita - BC-1000plus ANT+ Radio Wireless Body Composition Monitor",
  "Tanita - BC-1100F ANT+ Radio Wireless Body Composition Monitor",
  "Tanita - BC-1500 Ironman Radio Wireless Segmental Body Compositio",
  "Tanita - BF-2000 IronKids Radio Wireless Body Fat Monitor",
  "Tanita - HD-351ANT Radio Wireless ANT+™ Digital Weight Scale",
  "Tanita - HD400F ANT+™ Radio Wireless Digital Bathroom Scale",
  "Technogym - MYCYCLING",
  "Technogym - RIDE Stationary Bike",
  "Technogym - RUN Treadmill",
  "Technogym - Skillbike",
  "ThinkRider - BC200 GPS Smart Bike Computer",
  "ThinkRider - Power Trainer A1",
  "ThinkRider - X5 Smart Bike Trainer",
  "TIGRA Sport - TRIO 3-in1",
  "Timex - ANT+ Foot Pod Sensor",
  "Timex - Bike Speed + Cadence Sensor",
  "Timex - Digital 2.4 Heart Rate Sensor",
  "Timex - Ironman Run Trainer GPS HRM (various models)",
  "Titan - TraQ",
  "TopAction - Action Free",
  "TopAction - THR10",
  "TopAction - TMC10",
  "TopAction - TMS10",
  "TopAction - TSC10",
  "TQ Systems - TQ-HPR50",
  "Training Mate by Komodo Solutions - Training Mate",
  "Trek - CarBack Radar Rear Bike Light",
  "Tung Keng Enterprises Co. Ltd - D2R Smart Cycle Trainer",
  "Tung Keng Enterprises Co. Ltd - i-Wellness Series",
  "Turbo Trainer",
  "Vasa, Inc. - Vasa Swim Ergometer with ANT+ Power Meter",
  "VDO - ANT+ Cad-Kit / Z-Cad-Kit",
  "VDO - ANT+ Pulse Kit / Pulse Z",
  "VDO - ANT+ transmitter/Z Sender",
  "VDO - Comfort Gear",
  "Velo Reality Corp - VRide",
  "Velocomp - PowerPod",
  "Verve Cycling - InfoCrank",
  "VirtuGO App for OSX",
  "VirtuGO App for Windows",
  "Wahoo Fitness - ELEMNT RIVAL",
  "Wahoo Fitness - ELEMNT ROAM",
  "Wahoo Fitness - KICKR Power Trainer",
  "Wahoo Fitness - TICKR",
  "Wahoo Fitness - TICKR FIT",
  "Wahoo Fitness - TICKR Run",
  "Wahoo Fitness - TICKR X",
  "Wahoo Fitness - Wahoo - Kickr Bike",
  "Wahoo Fitness - Wahoo Bike Case for iPhone",
  "Wahoo Fitness - Wahoo Cycling Speed/Cadence Sensor",
  "Wahoo Fitness - Wahoo Heart Rate Monitor",
  "Wahoo Fitness - Wahoo Key for iPhone",
  "Wahoo Fitness - Wahoo RPM Cadence Sensor",
  "Wahoo Fitness - Wahoo Soft Heart Rate Strap",
  "Wahoo Fitness - Wahoo Stride Sensor",
  "Wahoo Fitness App",
  "Wahoo Fitness: Workout Tracker",
  "Wattbike - AtomX",
  "Wattbike - Performance Touchscreen",
  "Wattbike Performance Computer 2012",
  "Wattbike Performance Computer 2013",
  "Watteam Ltd. - POWERBEAT",
  "WeHunt Nordic AB - WeHunt",
  "wellcrafted software UG - myWorkouts",
  "Wireless Motorsport - BioTelemetry",
  "Woodway - Desmo Elite Treadmill",
  "Woodway - Desmo Treadmill",
  "Xpedo - APX COMP",
  "Xpedo - APX LITE",
  "Xpedo - APX PRO",
  "Xpedo - THRUST E",
  "Xplova - Cadence Combo Sensor",
  "Xplova - Heart Rate Sensor",
  "Yamaha Motor Co - Interface X",
  "Zwift HUB"
];

